export const NAME = 'appVersion';
